import React from 'react';
import { Quote } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    quote: 'Life Fort Solutions transformed how we approach our expansion strategy. Their unique blend of local insights and global best practices helped us successfully enter three new African markets in just 18 months.',
    author: 'Sarah Okafor',
    title: 'CEO, TechGrow Africa',
    location: 'Lagos, Nigeria',
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80'
  }, {
    quote: "As a personal brand, I was struggling to articulate my unique value proposition. The team at Life Fort helped me clarify my vision and develop a strategy that's authentic to who I am. My audience has grown 300% since working with them.",
    author: 'David Mensah',
    title: 'Leadership Coach & Speaker',
    location: 'Accra, Ghana',
    image: 'https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=735&q=80'
  }, {
    quote: 'Their hybrid approach was exactly what our organization needed. We learned so much during the process and now have the internal capability to execute our strategy with confidence. The ROI has been exceptional.',
    author: 'Amara Diallo',
    title: 'Executive Director, Future Forward Initiative',
    location: 'London, UK',
    image: 'https://images.unsplash.com/photo-1523824921871-d6f1a15151f1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80'
  }];
  return <section className="py-16 md:py-24 bg-gray-50" data-id="element-423">
      <div className="container mx-auto px-4" data-id="element-424">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-425">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-426">
            Client Success Stories
          </h2>
          <p className="text-lg text-gray-600" data-id="element-427">
            Don't just take our word for it. Here's what our clients across
            Africa and the Diaspora have to say.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-428">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-md" data-id="element-429">
              <Quote className="text-blue-300 mb-4" size={36} data-id="element-430" />
              <p className="text-gray-700 mb-6 italic" data-id="element-431">"{testimonial.quote}"</p>
              <div className="flex items-center" data-id="element-432">
                <div className="mr-4" data-id="element-433">
                  <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover" data-id="element-434" />
                </div>
                <div data-id="element-435">
                  <h4 className="font-bold text-gray-900" data-id="element-436">
                    {testimonial.author}
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-437">{testimonial.title}</p>
                  <p className="text-gray-500 text-sm" data-id="element-438">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};